import React from 'react'
import classes from '../assets/styles/Button.module.css'
const Button = ({label,type, disable=false,event}) => {
  return (
    <button type={type} className={classes.btn} disabled={disable} onClick={event}>{label}</button>
  )
}

export default Button;